var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle81(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 9.23333V10C18.3326 11.797 17.7507 13.5456 16.6748 14.9849C15.5988 16.4241 14.0864 17.4771 12.3631 17.9866C10.6399 18.4961 8.79804 18.4349 7.11238 17.8122C5.42673 17.1894 3.98754 16.0384 3.00946 14.5309C2.03138 13.0234 1.56682 11.2401 1.68506 9.44693C1.80329 7.6538 2.498 5.94694 3.66556 4.58089C4.83312 3.21485 6.41098 2.26282 8.16382 1.86679C9.91665 1.47076 11.7505 1.65195 13.392 2.38333",
    stroke: "#25AE25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33334L10 11.675L7.5 9.175",
    stroke: "#25AE25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle81);
export default __webpack_public_path__ + "static/media/check-circle (8) 1.1e231fae13f5ec46f5653ab6b52e2ec7.svg";
export { ForwardRef as ReactComponent };